var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-footer": "",
        "hide-header-close": _vm.jobUser && !_vm.validateJobUserInfo(),
        "no-close-on-esc": _vm.jobUser && !_vm.validateJobUserInfo(),
        "no-close-on-backdrop": _vm.jobUser && !_vm.validateJobUserInfo(),
        scrollable: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v("\n    ข้อมูลโปรไฟล์\n  ")
      ]),
      _vm._v(" "),
      _c("section", [
        _vm._.size(_vm.requireNameInputs) > 0
          ? _c("div", { staticClass: "form-group" }, [
              _c("h3", { staticClass: "text-danger text-center" }, [
                _vm._v("ไม่สามารถดำเนินการสนใจงานได้ "),
                _c("i", { staticClass: "fas fa-exclamation-circle" }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" โปรดระบุข้อมูลให้ครบถ้วน ")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "prefixName" } }, [
            _vm._v("คำนำหน้าชื่อ "),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("* จำเป็น")])
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.prefixName,
                  expression: "prefixName"
                }
              ],
              staticClass: "form-control",
              class: { "form-alert": _vm.errors.has("prefixName") },
              attrs: { name: "prefixName" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.prefixName = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v("เลือกคำนำหน้าชื่อ")
              ]),
              _vm._v(" "),
              _vm._l(_vm.prefixNames, function(item, index) {
                return _c("option", { key: index, domProps: { value: item } }, [
                  _vm._v("\n          " + _vm._s(item) + "\n        ")
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "name" } }, [
            _vm._v("ชื่อ-สกุล (ตามบัตรประชาชน) "),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("* จำเป็น")])
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            staticClass: "form-control",
            class: { "form-alert": _vm.errors.has("name") },
            attrs: { type: "text", id: "name", name: "name" },
            domProps: { value: _vm.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.has("name")
            ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "tel" } }, [
            _vm._v("เบอร์โทร "),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("* จำเป็น")])
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  required: true,
                  min: 10,
                  max: 15,
                  regex: /^\+?[0-9-]+$/
                },
                expression:
                  "{ required: true, min: 10, max: 15, regex: /^\\+?[0-9-]+$/ }"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tel,
                expression: "tel"
              }
            ],
            staticClass: "form-control",
            class: { "form-alert": _vm.errors.has("tel") },
            attrs: { type: "tel", id: "tel", name: "tel" },
            domProps: { value: _vm.tel },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.tel = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.has("tel")
            ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "age" } }, [
            _vm._v("วัน-เดือน-ปีเกิด "),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("* จำเป็น")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticClass: "flex-fill" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bDay,
                      expression: "bDay"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "form-alert": _vm.errors.has("bDay") },
                  attrs: { name: "bDay" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.bDay = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [_vm._v("วัน")]),
                  _vm._v(" "),
                  _vm._l(_vm.days, function(day, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: day } },
                      [
                        _vm._v(
                          "\n              " + _vm._s(day) + "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-fill px-3" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bMonth,
                      expression: "bMonth"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "form-alert": _vm.errors.has("bMonth") },
                  attrs: { name: "bMonth" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.bMonth = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("เดือน")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.months, function(month, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index + 1 } },
                      [
                        _vm._v(
                          "\n              " + _vm._s(month) + "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-fill" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.bYear,
                      expression: "bYear"
                    }
                  ],
                  staticClass: "form-control",
                  class: { "form-alert": _vm.errors.has("bYear") },
                  attrs: { name: "bYear" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.bYear = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("ปีพ.ศ.")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.years, function(year, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: year } },
                      [
                        _vm._v(
                          "\n              " + _vm._s(year) + "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "age" } }, [
            _vm._v("จังหวัด และเขต/อำเภอที่ฉันอยู่ (ปัจจุบัน) "),
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("* จำเป็น")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col-6 pr-2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.addressProvinceId,
                      expression: "addressProvinceId"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "form-alert":
                      _vm.errors.has("addressProvince") ||
                      (_vm._.findKey("address_province_id") &&
                        !_vm.addressProvinceId)
                  },
                  attrs: { name: "addressProvince" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.addressProvinceId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.booking.contact_step.set_province")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sortedProvinces, function(addressProvince, index) {
                    return _c(
                      "option",
                      { domProps: { value: addressProvince.id } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("multiLangName")(addressProvince)) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.errors.has("addressProvince") ||
              (_vm._.findKey("address_province_id") && !_vm.addressProvinceId)
                ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 pl-2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.districtId,
                      expression: "districtId"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "form-alert":
                      _vm.errors.has("district") ||
                      (_vm._.findKey("district") && !_vm.districtId)
                  },
                  attrs: { name: "district" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.districtId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.booking.contact_step.set_district")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sortedDistricts, function(district, index) {
                    return _c("option", { domProps: { value: district.id } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("multiLangName")(district)) +
                          "\n            "
                      )
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.errors.has("district") ||
              (_vm._.findKey("district") && !_vm.districtId)
                ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n          "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mb-3" }, [
          _c("div", { staticClass: "flex-fill py-1" }, [
            _c("label", { attrs: { for: "maritalStatus" } }, [
              _vm._v("สถานภาพ "),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("* จำเป็น")
              ])
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.maritalStatus,
                    expression: "maritalStatus"
                  }
                ],
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("maritalStatus") },
                attrs: { name: "maritalStatus", id: "maritalStatus" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.maritalStatus = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("เลือกสถานภาพ")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "โสด" } }, [_vm._v("โสด")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "สมรส" } }, [_vm._v("สมรส")])
              ]
            ),
            _vm._v(" "),
            _vm.errors.has("maritalStatus")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mb-3" }, [
          _c("div", { staticClass: "flex-fill py-1" }, [
            _c("h4", [_vm._v("ทักษะขับรถยนต์")]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drivingCar,
                    expression: "drivingCar"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "drivingCar",
                  value: "ขับไม่ได้"
                },
                domProps: { checked: _vm._q(_vm.drivingCar, "ขับไม่ได้") },
                on: {
                  change: function($event) {
                    _vm.drivingCar = "ขับไม่ได้"
                  }
                }
              }),
              _vm._v(" ขับไม่ได้\n        ")
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drivingCar,
                    expression: "drivingCar"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "drivingCar",
                  value: "ขับได้มีใบขับขี่"
                },
                domProps: {
                  checked: _vm._q(_vm.drivingCar, "ขับได้มีใบขับขี่")
                },
                on: {
                  change: function($event) {
                    _vm.drivingCar = "ขับได้มีใบขับขี่"
                  }
                }
              }),
              _vm._v(" ขับได้มีใบขับขี่\n        ")
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drivingCar,
                    expression: "drivingCar"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "drivingCar",
                  value: "ขับได้ไม่มีใบขับขี่"
                },
                domProps: {
                  checked: _vm._q(_vm.drivingCar, "ขับได้ไม่มีใบขับขี่")
                },
                on: {
                  change: function($event) {
                    _vm.drivingCar = "ขับได้ไม่มีใบขับขี่"
                  }
                }
              }),
              _vm._v(" ขับได้ไม่มีใบขับขี่\n        ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mb-3" }, [
          _c("div", { staticClass: "flex-fill py-1" }, [
            _c("h4", [_vm._v("ทักษะขับรถมอเตอร์ไซค์")]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drivingMotorcycle,
                    expression: "drivingMotorcycle"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "drivingMotorcycle",
                  value: "ขับไม่ได้"
                },
                domProps: {
                  checked: _vm._q(_vm.drivingMotorcycle, "ขับไม่ได้")
                },
                on: {
                  change: function($event) {
                    _vm.drivingMotorcycle = "ขับไม่ได้"
                  }
                }
              }),
              _vm._v(" ขับไม่ได้\n        ")
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drivingMotorcycle,
                    expression: "drivingMotorcycle"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "drivingMotorcycle",
                  value: "ขับได้มีใบขับขี่"
                },
                domProps: {
                  checked: _vm._q(_vm.drivingMotorcycle, "ขับได้มีใบขับขี่")
                },
                on: {
                  change: function($event) {
                    _vm.drivingMotorcycle = "ขับได้มีใบขับขี่"
                  }
                }
              }),
              _vm._v(" ขับได้มีใบขับขี่\n        ")
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.drivingMotorcycle,
                    expression: "drivingMotorcycle"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: "drivingMotorcycle",
                  value: "ขับได้ไม่มีใบขับขี่"
                },
                domProps: {
                  checked: _vm._q(_vm.drivingMotorcycle, "ขับได้ไม่มีใบขับขี่")
                },
                on: {
                  change: function($event) {
                    _vm.drivingMotorcycle = "ขับได้ไม่มีใบขับขี่"
                  }
                }
              }),
              _vm._v(" ขับได้ไม่มีใบขับขี่\n        ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mb-3" }, [
          _c("div", { staticClass: "flex-fill py-1" }, [
            _c("label", [
              _vm._v("โรคประจำตัว (หากไม่มีให้ใส่เครื่องหมายขีด - ) "),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("* จำเป็น")
              ])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.disease,
                  expression: "disease"
                }
              ],
              staticClass: "form-control",
              class: {
                "form-alert":
                  _vm.errors.has("disease") ||
                  (_vm._.findKey("disease") && !_vm.disease)
              },
              attrs: { type: "text", name: "disease" },
              domProps: { value: _vm.disease },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.disease = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("disease") ||
            (_vm._.findKey("disease") && !_vm.disease)
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mb-3" }, [
          _c("div", { staticClass: "flex-fill py-1" }, [
            _c("label", [
              _vm._v("แนะนำตัวเอง "),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("* จำเป็น")
              ])
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.introduce,
                  expression: "introduce"
                }
              ],
              staticClass: "form-control",
              class: {
                "form-alert":
                  _vm.errors.has("introduce") ||
                  (_vm._.findKey("introduce") && !_vm.introduce)
              },
              attrs: { name: "introduce", id: "introduce", rows: "4" },
              domProps: { value: _vm.introduce },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.introduce = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("introduce") ||
            (_vm._.findKey("introduce") && !_vm.introduce)
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex mb-3" }, [
          _c("div", { staticClass: "flex-fill py-1" }, [
            _c("label", [
              _vm._v("ประสบการณ์ทำงาน "),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("* จำเป็น")
              ])
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.workingExperience,
                  expression: "workingExperience"
                }
              ],
              staticClass: "form-control",
              class: {
                "form-alert":
                  _vm.errors.has("workingExperience") ||
                  (_vm._.findKey("working_experience") &&
                    !_vm.workingExperience)
              },
              attrs: {
                name: "workingExperience",
                id: "workingExperience",
                rows: "4"
              },
              domProps: { value: _vm.workingExperience },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.workingExperience = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("workingExperience") ||
            (_vm._.findKey("working_experience") && !_vm.workingExperience)
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            { staticClass: "flex-fill" },
            [
              _c("h3", [_vm._v("ทักษะของฉัน")]),
              _vm._v(" "),
              _vm._l(_vm.jobSkills, function(jobSkill, index) {
                return _c("div", { key: index, staticClass: "py-1" }, [
                  _c("label", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: jobSkill.id,
                        checked: _vm.hasSkill(jobSkill.id)
                      },
                      on: { change: _vm.changeHasSkill }
                    }),
                    _vm._v("  " + _vm._s(jobSkill.name) + "\n          ")
                  ])
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-fill" },
            [
              _c("h3", [_vm._v("ภาษาที่ฉันสื่อสารได้")]),
              _vm._v(" "),
              _vm._l(_vm.jobLanguages, function(jobLanguage, index) {
                return _c("div", { key: index, staticClass: "py-1" }, [
                  _c("label", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      domProps: {
                        value: jobLanguage.id,
                        checked: _vm.hasLanguage(jobLanguage.id)
                      },
                      on: { change: _vm.changeHasLanguage }
                    }),
                    _vm._v(
                      "  " +
                        _vm._s(
                          jobLanguage.name === "Thai"
                            ? jobLanguage.native
                            : jobLanguage.name
                        ) +
                        "\n          "
                    )
                  ])
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-3 row no-gutters" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-block",
                attrs: { disabled: _vm.isLoading },
                on: {
                  click: function($event) {
                    return _vm.saveData()
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.isLoading ? "กำลังบันทึก..." : "บันทึก") +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1b86c22", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1b86c22","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/UpdateProfileModal.vue
// module id = 2327
// module chunks = 0